const PrivacyPolicy = () => (
    <div style={{ fontSize: 13, lineHeight: 1.9 }}>
        <p style={{ marginBottom: 16 }}>
            (주)에이아이에스(이하 '회사')는 이용자의 개인정보를 보호하고, 이와
            관련한 고충을 신속하고 원활하게 처리할 수 있도록 다음과 같이
            개인정보처리방침을 수립하여 공개합니다.
        </p>

        {/* ── 1. 수집 이용 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>
            1. 개인정보의 수집 이용
        </h4>
        <p style={{ marginBottom: 8 }}>
            회사는 회원가입과 상담, 각종 서비스의 제공 등을 위해 아래와 같은
            개인정보를 수집하고 있습니다. 이용자의 개인정보는 소속업체에서
            이용자의 동의 절차를 거쳐 수집됩니다.
        </p>

        <p>
            <strong>① 수집항목</strong>
        </p>
        <ul style={{ paddingLeft: 20, marginBottom: 10 }}>
            <li style={{ marginBottom: 4 }}>
                <strong>이용자:</strong> 사진, 이름, 아이디, 휴대전화번호,
                이메일주소, 주소, 생년월일, 성별, 위치정보,
                주민등록번호(외국인의 경우 외국인 등록번호), 계좌정보(은행명,
                예금주, 계좌번호)
            </li>
            <li style={{ marginBottom: 4 }}>
                <strong>기업회원의 경우 추가 수집:</strong> 회사명,
                대표전화번호, 이메일주소, 사업자 등록번호, 대표자 정보, 주소
            </li>
            <li style={{ marginBottom: 4 }}>
                <strong>이용자 위치정보 (자동 생성):</strong> 접속지 정보, 쿠키,
                기기고유번호, 서비스 이용기록, 방문기록
            </li>
            <li style={{ marginBottom: 4 }}>
                <strong>외국인의 경우 추가 수집:</strong> 국적, 비자유형
            </li>
        </ul>

        <p>
            <strong>② 개인정보의 수집방법</strong>
        </p>
        <ul style={{ paddingLeft: 20, marginBottom: 10 }}>
            <li>
                웹페이지, 모바일 애플리케이션, 서면양식, 팩스, 고객센터를 통한
                전화와 온라인 상담, 이벤트 응모 등
            </li>
            <li>생성정보 수집 도구를 통한 자동 수집</li>
        </ul>

        <p>
            <strong>③ 이용 목적</strong>
        </p>
        <ul style={{ paddingLeft: 20, marginBottom: 10 }}>
            <li>서비스의 원활한 제공 및 운영</li>
            <li>개인 식별 및 본인확인</li>
            <li>소속 등록 및 운영</li>
            <li>
                보험가입 여부 확인 및 보험 관리(보험가입, 보험료 책정, 사고접수,
                사고조사 등)
            </li>
            <li>공지사항 전달 및 불법·부정 이용 방지</li>
            <li>문의 및 상담, 서비스 이용 기록 통계 및 분석</li>
            <li>이벤트 정보 및 참여기회 제공, 마케팅 및 프로모션</li>
            <li>맞춤 서비스 제공</li>
        </ul>

        <p>
            <strong>④ 개인정보 보유 및 이용기간</strong>
        </p>
        <ul style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li>
                이용자의 정보(이름, 생년월일, 휴대전화번호, 이메일주소)는 회원
                탈퇴 후 15일 뒤 파기됩니다.
            </li>
            <li>
                소속계약이 완료된 이용자의 모든 개인정보는 계약종료 15일 후
                파기됩니다.
            </li>
        </ul>

        {/* ── 2. 제3자 제공 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>
            2. 개인정보의 제3자 제공
        </h4>
        <p style={{ marginBottom: 8 }}>
            회사는 이용자의 개인정보를 명시한 목적의 범위 내에서 처리하며,
            이용자의 사전 동의 없이 이용범위를 초과하여 처리하거나 제3자에게
            제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다.
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 4 }}>이용자가 사전에 동의한 경우</li>
            <li style={{ marginBottom: 4 }}>
                법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와
                방법에 따라 수사기관의 요구가 있는 경우
            </li>
        </ol>

        {/* ── 3. 처리위탁 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>
            3. 개인정보의 처리위탁
        </h4>
        <p style={{ marginBottom: 8 }}>
            회사는 개인정보 업무처리를 위하여 다음과 같이 이용자의 개인정보를
            위탁하고 있으며, 관계 법령에 따라 수탁자가 개인정보를 안전하게
            처리하는지를 감독하고 있습니다.
        </p>
        <table
            style={{
                width: '100%',
                borderCollapse: 'collapse',
                marginBottom: 12,
                fontSize: 12,
            }}
        >
            <thead>
                <tr style={{ background: '#f5f5f5' }}>
                    <th
                        style={{
                            border: '1px solid #ddd',
                            padding: '6px 10px',
                            textAlign: 'left',
                        }}
                    >
                        수탁업체
                    </th>
                    <th
                        style={{
                            border: '1px solid #ddd',
                            padding: '6px 10px',
                            textAlign: 'left',
                        }}
                    >
                        위탁업무의 내용
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td
                        style={{
                            border: '1px solid #ddd',
                            padding: '6px 10px',
                        }}
                    >
                        계약된 대행사
                    </td>
                    <td
                        style={{
                            border: '1px solid #ddd',
                            padding: '6px 10px',
                        }}
                    >
                        생육관리시스템 이용자 관리, 농작업 관제 시스템 운영
                    </td>
                </tr>
                <tr>
                    <td
                        style={{
                            border: '1px solid #ddd',
                            padding: '6px 10px',
                        }}
                    >
                        NICE평가정보(주), SCI평가정보(주)
                    </td>
                    <td
                        style={{
                            border: '1px solid #ddd',
                            padding: '6px 10px',
                        }}
                    >
                        본인인증
                    </td>
                </tr>
                <tr>
                    <td
                        style={{
                            border: '1px solid #ddd',
                            padding: '6px 10px',
                        }}
                    >
                        메시지 발송 서비스 업체
                    </td>
                    <td
                        style={{
                            border: '1px solid #ddd',
                            padding: '6px 10px',
                        }}
                    >
                        메시지 발송 서비스
                    </td>
                </tr>
                <tr>
                    <td
                        style={{
                            border: '1px solid #ddd',
                            padding: '6px 10px',
                        }}
                    >
                        주식회사 에이아이에스
                    </td>
                    <td
                        style={{
                            border: '1px solid #ddd',
                            padding: '6px 10px',
                        }}
                    >
                        서비스 제공을 위한 시스템 개발 및 운영
                    </td>
                </tr>
            </tbody>
        </table>

        {/* ── 4. 파기 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>4. 개인정보의 파기</h4>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                회사는 개인정보가 불필요하게 되었을 때 지체 없이 파기합니다.
                다만, 다음의 경우에는 명시한 기간 동안 보유합니다.
                <ul style={{ paddingLeft: 18, marginTop: 4 }}>
                    <li>
                        상법 등 법령에 따라 보존이 필요한 경우: 법령에서 규정한
                        기간
                    </li>
                    <li>소비자의 불만 또는 분쟁처리에 관한 기록: 3년</li>
                    <li>부정이용 등에 관한 기록: 5년</li>
                </ul>
            </li>
            <li style={{ marginBottom: 6 }}>
                전자적 파일형태의 개인정보는 기술적 또는 물리적 방법으로
                파기하며, 출력된 개인정보는 분쇄기로 분쇄하거나 소각하여
                파기합니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                회원이 2년간 서비스 이용기록이 없는 경우 회원에게 사전 통지하고
                별도로 분리하여 저장합니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                회사는 이용자로부터 취득 또는 생성한 개인정보를 AWS(Amazon Web
                Service)가 보유하고 있는 데이터베이스(물리적 보관소: 한국,
                일본)에 저장합니다. AWS는 해당 서버의 물리적인 관리만을 행하고,
                원칙적으로 회원님의 개인정보에 접근하지 않습니다.
            </li>
        </ol>

        {/* ── 5. 권리와 행사방법 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>
            5. 이용자 및 법정대리인의 권리와 그 행사방법
        </h4>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                이용자 및 법정대리인은 등록되어 있는 개인정보를 언제든지
                서비스를 통해 조회 및 수정할 수 있으며 가입 해지를 요청할 수
                있습니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                개인정보 열람, 정정, 삭제는 담당자에게 서면, 전자우편,
                모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대해 지체
                없이 조치합니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                정정 요청 시 정정이 완료되기 전까지 해당 개인정보를 이용 또는
                제공하지 않습니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                이용자는 자신의 개인정보를 최신 상태로 유지해야 하며, 부정확한
                정보 입력으로 발생하는 문제의 책임은 이용자에게 있습니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                타인의 개인정보를 도용하는 경우 이용자 자격을 상실하거나 관련
                법령에 의해 처벌받을 수 있습니다.
            </li>
        </ol>

        {/* ── 6. 자동수집장치 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>
            6. 개인정보 자동수집장치의 설치와 운영 및 거부
        </h4>
        <p style={{ marginBottom: 12 }}>
            회사는 이용자의 쿠키를 저장하지 않습니다.
        </p>

        {/* ── 7. 위치기반정보 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>
            7. 위치기반정보의 수집
        </h4>
        <p style={{ marginBottom: 12 }}>
            회사는 서비스 제공을 위해 위치기반정보를 수집할 수 있으며, 이에
            관하여는 "위치기반서비스 이용약관"을 참고하시길 바랍니다.
        </p>

        {/* ── 8. 안전성 확보 조치 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>
            8. 개인정보의 안전성 확보 조치
        </h4>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                로그인에 사용되는 비밀번호는 암호화되어 저장·관리되고 있으며,
                본인만이 알고 있습니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                회사는 개인정보보호 이행사항 및 담당자의 준수여부를 확인하여
                문제 발견 시 즉시 해결하고 바로잡을 수 있도록 최선을 다하고
                있습니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                최신 백신프로그램을 이용하여 이용자들의 개인정보나 자료가
                유출되거나 손상되지 않도록 방지하고 있습니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                개인정보는 암호화를 통하여 안전하게 저장·관리되고 있습니다.
            </li>
        </ol>

        {/* ── 9. 보호책임자 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>
            9. 개인정보보호책임자
        </h4>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                회사는 개인정보 처리에 관한 업무를 총괄하고 이용자의 불만처리 및
                피해구제를 위하여 다음과 같이 개인정보 보호책임자를 지정하고
                있습니다.
                <ul style={{ paddingLeft: 18, marginTop: 4 }}>
                    <li>개인정보 보호책임자: 김민석</li>
                    <li>직책: 대표이사</li>
                    <li>연락처: 070-5158-5952</li>
                    <li>전자우편: cs@aiskorea.co.kr</li>
                </ul>
            </li>
            <li style={{ marginBottom: 6 }}>
                이용자는 서비스를 이용하면서 발생한 모든 개인정보 관련 문의,
                불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 또는
                담당부서로 문의하실 수 있습니다. 회사는 이용자의 문의에 대해
                지체 없이 답변 및 처리합니다.
            </li>
        </ol>

        {/* ── 10. 기타 신고 및 상담 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>
            10. 개인정보 침해에 대한 신고 및 상담
        </h4>
        <p style={{ marginBottom: 8 }}>
            이용자는 다음의 기관에 개인정보 침해에 대한 피해구제, 상담 등을
            문의하실 수 있습니다.
        </p>
        <ul style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                <strong>개인정보침해신고센터</strong>
                <br />
                홈페이지: http://privacy.kisa.or.kr &nbsp;|&nbsp; 전화번호:
                (국번없이) 118
            </li>
            <li style={{ marginBottom: 6 }}>
                <strong>개인정보분쟁조정위원회</strong>
                <br />
                홈페이지: https://www.kopico.go.kr &nbsp;|&nbsp; 전화번호:
                1833-6972
            </li>
            <li style={{ marginBottom: 6 }}>
                <strong>대검찰청 사이버범죄수사단</strong>
                <br />
                홈페이지: http://www.spo.go.kr &nbsp;|&nbsp; 전화번호:
                (국번없이) 1301
            </li>
            <li style={{ marginBottom: 6 }}>
                <strong>경찰청 사이버테러대응센터</strong>
                <br />
                홈페이지: https://ecrm.police.go.kr &nbsp;|&nbsp; 전화번호:
                (국번없이) 182
            </li>
        </ul>

        {/* ── 11. 고지의 의무 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>11. 고지의 의무</h4>
        <ol style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 6 }}>
                현 개인정보처리방침은 법령, 정부의 정책 또는 회사 내부정책 등
                필요에 의하여 변경될 수 있으며, 내용 추가·삭제 및 수정이 있을
                시에는 개정 최소 7일 전부터 홈페이지의 '공지사항'을 통해 고지할
                것입니다.
            </li>
            <li style={{ marginBottom: 6 }}>
                현 개인정보처리방침은 2026년 3월 19일부터 적용되며, 변경 전의
                개인정보처리방침은 공지사항을 통해서 확인하실 수 있습니다.
            </li>
        </ol>

        <p style={{ marginTop: 24, color: '#888', fontSize: 12 }}>
            공고일자: 2026년 3월 19일 &nbsp;|&nbsp; 시행일자: 2026년 3월 19일
        </p>
    </div>
);

export default PrivacyPolicy;
